/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './diag-lab-panel.reducer';

export const DiagLabPanelDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const diagLabPanelEntity = useAppSelector(state => state.diagLabPanel.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="diagLabPanelDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.diagLabPanel.detail.title">DiagLabPanel</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.diagLabPanel.id">Id</Translate>
            </span>
          </dt>
          <dd>{diagLabPanelEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.diagLabPanel.active">Active</Translate>
            </span>
          </dt>
          <dd>{diagLabPanelEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.diagLabPanel.description">Description</Translate>
            </span>
          </dt>
          <dd>{diagLabPanelEntity.description}</dd>
          <dt>
            <span id="displayKey">
              <Translate contentKey="tinyMedicRestApp.diagLabPanel.displayKey">Display Key</Translate>
            </span>
          </dt>
          <dd>{diagLabPanelEntity.displayKey}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.diagLabPanel.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{diagLabPanelEntity.lastUpdated}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.diagLabPanel.name">Name</Translate>
            </span>
          </dt>
          <dd>{diagLabPanelEntity.name}</dd>
          <dt>
            <span id="sample">
              <Translate contentKey="tinyMedicRestApp.diagLabPanel.sample">Sample</Translate>
            </span>
          </dt>
          <dd>{diagLabPanelEntity.sample}</dd>
          <dt>
            <span id="sortOrder">
              <Translate contentKey="tinyMedicRestApp.diagLabPanel.sortOrder">Sort Order</Translate>
            </span>
          </dt>
          <dd>{diagLabPanelEntity.sortOrder}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.diagLabPanel.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{diagLabPanelEntity.timestampEntry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.diagLabPanel.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{diagLabPanelEntity.microSec}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.diagLabPanel.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{diagLabPanelEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diagLabPanel.diagLab">Diag Lab</Translate>
          </dt>
          <dd>{diagLabPanelEntity.diagLab ? diagLabPanelEntity.diagLab.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/diag-lab-panel" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/diag-lab-panel/${diagLabPanelEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DiagLabPanelDetail;
